/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const RULE_SELECTOR = 'input[data-rule-of-three]';
  const CART_LINE_SELECTOR = '[data-cart-item]';
  const RULE_INCREMENT = 3;
  const RULE_ERROR = 'This product must be ordered in multiples of 3.';

  function getRuleField(target) {
    const cartLine = target.closest(CART_LINE_SELECTOR);

    if (!cartLine) {
      return null;
    }

    const field = cartLine.querySelector(RULE_SELECTOR);
    return field ? {cartLine, field} : null;
  }

  function isValidQuantity(value) {
    return Number.isInteger(value) && value >= RULE_INCREMENT && value % RULE_INCREMENT === 0;
  }

  function showRuleError(cartLine, field) {
    const cart = cartLine.closest('[data-cart-page], [data-cart-drawer]') || document;
    const errors = cart.querySelector('[data-cart-errors]');
    const message = errors && errors.querySelector('[data-error-message]');

    if (message) {
      message.textContent = RULE_ERROR;
      errors.classList.add('is-expanded');
    }

    field.setCustomValidity(RULE_ERROR);
    field.reportValidity();
    field.setCustomValidity('');
  }

  function updateField(field, value) {
    field.value = value;
    field.dataset.lastValidQuantity = value;
    field.dispatchEvent(new Event('input', {bubbles: true}));
  }

  document.addEventListener('focusin', function(event) {
    if (!event.target.matches(RULE_SELECTOR)) {
      return;
    }

    const value = Number(event.target.value);
    if (isValidQuantity(value)) {
      event.target.dataset.lastValidQuantity = value;
    }
  });

  document.addEventListener('input', function(event) {
    if (!event.target.matches(RULE_SELECTOR)) {
      return;
    }

    const rule = getRuleField(event.target);
    const value = Number(event.target.value);

    if (rule && isValidQuantity(value)) {
      event.target.dataset.lastValidQuantity = value;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (rule) {
      const previousValue = Number(event.target.dataset.lastValidQuantity);
      event.target.value = isValidQuantity(previousValue) ? previousValue : RULE_INCREMENT;
      showRuleError(rule.cartLine, event.target);
    }
  }, true);

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');

    if (!button) {
      return;
    }

    const rule = getRuleField(button);
    if (!rule) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const currentValue = Number(rule.field.value);
    const validCurrentValue = isValidQuantity(currentValue) ? currentValue : RULE_INCREMENT;

    if (button.matches('[data-quantity-minus]')) {
      if (validCurrentValue === RULE_INCREMENT) {
        const removeButton = rule.cartLine.querySelector('[data-item-remove]');
        if (removeButton) {
          removeButton.click();
        }
        return;
      }

      updateField(rule.field, validCurrentValue - RULE_INCREMENT);
      return;
    }

    updateField(rule.field, validCurrentValue + RULE_INCREMENT);
  }, true);






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
